<template>
    <div class="grid grid-cols-6 mb-4">
        <div class="md:col-start-3 md:col-span-2 col-start-1 col-span-6 text-center">
            <img class="w-25 h-20 mx-auto" :src="nft.localFileUrl" alt="" />
        </div>
    </div>
</template>

<script>

export default {
    props: {
        nft: Object,
    },
}

</script>
